var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 60,
    viewBox: "0 0 115 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3645_55600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 115,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3645_55600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6612 19.6769L52.4062 27.3047L145.637 -128.471L132.892 -136.099L39.6612 19.6769Z",
    fill: "#8DE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1637 22.977L47.9141 24.623L125.121 -104.38L122.371 -106.026L45.1637 22.977Z",
    fill: "#297CCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1364 45.0364L52.3993 27.3097L39.6564 19.6832L33.1364 45.0364Z",
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2759 42.1555L34.2099 40.919C34.2099 40.919 30.1968 48.2239 30.9514 48.7078C31.7059 49.1918 36.2759 42.1555 36.2759 42.1555Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M46.8738 31.0851C47.5519 30.5173 48.2607 29.9031 48.526 29.0618C48.7912 28.2205 48.3779 27.1025 47.506 26.9572C46.6341 26.8118 45.977 27.5804 45.4388 28.2437C44.371 29.5643 43.1862 30.7857 41.8987 31.8931C41.0944 32.5883 36.0491 37.6517 39.4923 37.1917C40.5604 37.0485 42.3651 34.8489 43.2076 34.1589L46.8738 31.0851Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3e0e274b6600d0a6b54e3b88765a1e28.svg";
export { ForwardRef as ReactComponent };